import { useState } from 'react';
import {
  PasswordStrength,
  type PasswordStrengthTypes,
} from '@/utils/passwordStrength/passwordStrength.types';

export const usePasswordStrength = () => {
  const [passwordStrength, setPasswordStrength] =
    useState<PasswordStrengthTypes | null>(null);
  const isWeakPassword = passwordStrength === PasswordStrength.WEAK;
  return {
    isWeakPassword,
    passwordStrength,
    setPasswordStrength,
  };
};
